export default "/images/0a39923a0ab0a8ded11dd4b77efc0968.avif";